import { useCMSPageField } from '@/cms/fields'

import { mqMin, space } from '@sunwebgroup/ui-components'
import { Button, Sheet } from '@sunwebgroup/ui-components/uds'

import * as React from 'react'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'
import { RoomType } from './RoomType'

const Trigger = styled(Button)`
  @media ${mqMin('primitives_breakpoint_l_min')} {
    align-self: flex-start;
  }
`

const SheetContent = styled(Sheet.Content)`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_8')};

`

function ShowAllRoomTypes({ onOpenChange }: {
  onOpenChange: (isOpen: boolean) => void
}): React.ReactElement {
  const roomTypes = useCMSPageField('PDP.roomTypes')
  const intl = useIntl()

  return (
    <Sheet.Root onOpenChange={onOpenChange}>
      <Sheet.Trigger>
        <Trigger $type="outlinedPrimary">{intl.formatMessage({ id: 'roomtypes_show_more_label' }, { amount_roomtypes: roomTypes.length })}</Trigger>
      </Sheet.Trigger>
      <Sheet.Body side="right">
        <Sheet.Header titleLabel={intl.formatMessage({ id: 'roomtypes_heading' })} closeLabel={intl.formatMessage({ id: 'close' })} />
        <SheetContent>
          {roomTypes.map(roomType => (
            <RoomType roomType={roomType} key={roomType.id} />
          ))}
        </SheetContent>
      </Sheet.Body>
    </Sheet.Root>
  )
}

export default styled(ShowAllRoomTypes)``
